import { useCookies } from '@packages/utilities';
import { getHasNewInfiniteScrolling } from './useHasNewInfiniteScrolling';

export const getDefaultPageSize = (cookies: Record<string, string>) => {
  const hasNewInfiniteScrolling = getHasNewInfiniteScrolling(cookies);

  // actual visible card count is 36 and 74 when including the search buddy teaser cards
  return hasNewInfiniteScrolling ? 35 : 72;
};

export const useDefaultPageSize = () => {
  const { getCookies } = useCookies();

  return getDefaultPageSize(getCookies());
};
